import { StatusCodes } from "http-status-codes";
import { getErrorPageForErrorCode } from "../config/Config";

let appErrorHandler;

export function setErrorHandler(someFn) {
  appErrorHandler = someFn;
}

function request(
  url,
  params = {},
  method,
  withCredentials = true,
  ignoreRedirect = false,
  ignoreJson = false,
  signal = null,
  retryCount = 1,
  body = {}
) {
  const options = { method: method };
  let urlWithParams = url;
  if (signal) {
    options.signal = signal;
  }
  if (withCredentials) {
    options.credentials = "include";
  }
  if (!!params && Object.keys(params).length > 0) {
    urlWithParams += "?" + new URLSearchParams(params).toString();
  }
  if (method !== "GET") {
    if (body instanceof FormData) {
      options.body = body;
    } else if (!!body && Object.keys(body).length > 0) {
      options.body = JSON.stringify(body);
    }
  }

  return fetch(urlWithParams, options)
    .then((res) => {
      if (res.ok) {
        return ignoreJson ? res : res.json();
      }
      return Promise.reject(res);
    })
    .catch((res) => {
      if (window["ddlDebug"]) {
        console.error("Fetch error: ", res);
      }
      const status =
        res instanceof Response ? res.status : StatusCodes.BAD_GATEWAY;
      if (
        appErrorHandler &&
        (status === StatusCodes.UNAUTHORIZED ||
          status === StatusCodes.NOT_FOUND)
      ) {
        if (ignoreRedirect) {
          return Promise.reject(res);
        }
        const errorPage = getErrorPageForErrorCode(status);
        if (window.location.href.endsWith(errorPage)) {
          // already on the error page, no need to redirect
        } else {
          appErrorHandler(errorPage);
        }
        return;
      }
      // Retry ONCE on 504 Gateway Timeout for GET requests
      if (
        (status === StatusCodes.GATEWAY_TIMEOUT ||
          !(res instanceof Response)) &&
        method === "GET" &&
        retryCount > 0
      ) {
        return request(
          url,
          params,
          method,
          withCredentials,
          ignoreRedirect,
          ignoreJson,
          signal,
          retryCount - 1
        );
      }
      return Promise.reject(res);
    });
}

export function getRequest(url, params, ignoreRedirect = false, signal = null) {
  return request(url, params, "GET", true, ignoreRedirect, false, signal);
}

export function postRequest(
  url,
  body,
  withCredentials = true,
  ignoreRedirect = false,
  ignoreJson = false,
  signal = null,
  params
) {
  return request(
    url,
    params,
    "POST",
    withCredentials,
    ignoreRedirect,
    ignoreJson,
    signal,
    1,
    body
  );
}

export function putRequest(
  url,
  body,
  withCredentials = true,
  ignoreRedirect = false,
  ignoreJson = false,
  signal = null,
  params
) {
  return request(
    url,
    params,
    "PUT",
    withCredentials,
    ignoreRedirect,
    ignoreJson,
    signal,
    1,
    body
  );
}

export function patchRequest(
  url,
  body,
  withCredentials = true,
  ignoreRedirect = false,
  ignoreJson = false,
  signal = null,
  params
) {
  return request(
    url,
    params,
    "PATCH",
    withCredentials,
    ignoreRedirect,
    ignoreJson,
    signal,
    1,
    body
  );
}

export function deleteRequest(
  url,
  body,
  withCredentials = true,
  ignoreRedirect = false,
  ignoreJson = false,
  signal = null,
  params
) {
  return request(
    url,
    params,
    "DELETE",
    withCredentials,
    ignoreRedirect,
    ignoreJson,
    signal,
    1,
    body
  );
}
